import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "className"];
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
var StatsWidgets = function StatsWidgets(props) {
  var children = props.children,
    className = props.className,
    remainingProps = _objectWithoutProperties(props, _excluded);
  var classes = classNames('StatsWidget-wrapper', className);
  return /*#__PURE__*/React.createElement("div", _extends({}, remainingProps, {
    className: classes
  }), children);
};
StatsWidgets.propTypes = {
  className: PropTypes.string
};
export default StatsWidgets;